import { Extension } from "@tiptap/core";
import { EditorState, Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { CHECK_FOR_UNDERSTANDING_BLOCK } from "@/view/TiptapArticleBody/extensions/ChecksForUnderstanding";
import { getDynamicData } from "../DataProvider/utils";
import { blurCss } from "./BlurDecorator.style";
import shouldIgnoreArticleBlur from "./utils/shouldIgnoreArticleBlur";

const sharedAttributes = {
  "aria-hidden": "true",
  inert: "true",
};

const blurDecoratorPluginKey = new PluginKey("blurDecorator");

export const BlurDecorator = Extension.create({
  name: "blurDecorator",
  group: "inline",
  inline: true,
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: blurDecoratorPluginKey,
        props: {
          decorations: (state: EditorState) => {
            const { doc } = state;
            const { assignment, userProperties, isStudentPreviewOn } =
              getDynamicData(state);
            const shouldIgnoreBlur = shouldIgnoreArticleBlur({
              assignment,
              userProperties,
              isStudentPreviewOn,
            });
            if (shouldIgnoreBlur) {
              return DecorationSet.create(doc, []);
            }

            const decorations = [];
            let nextUnSubmittedQuizIndex: number | null = null;

            doc.descendants((node, index) => {
              if (
                nextUnSubmittedQuizIndex === null &&
                node.type.name === CHECK_FOR_UNDERSTANDING_BLOCK &&
                !node.attrs["isCorrectSubmission"]
              ) {
                nextUnSubmittedQuizIndex = index;
              }
            });
            if (nextUnSubmittedQuizIndex !== null) {
              const endOfDocumentPosition = doc.content.size;

              decorations.push(
                Decoration.inline(
                  nextUnSubmittedQuizIndex,
                  endOfDocumentPosition,
                  {
                    ...sharedAttributes,
                    class: blurCss,
                  },
                ),
              );
              // do the same for custom nodes
              doc.descendants((node, pos) => {
                if (nextUnSubmittedQuizIndex !== null) {
                  if (pos > nextUnSubmittedQuizIndex) {
                    decorations.push(
                      Decoration.node(pos, pos + node.nodeSize, {
                        ...sharedAttributes,
                        class: blurCss,
                      }),
                    );
                  }
                }
              });
            }
            return DecorationSet.create(doc, decorations);
          },
        },
      }),
    ];
  },
});
